var exports = {
  "k": "xdbfd91f1--897809--container",
  "i": "xdbfd91f1--897809--wrapper",
};

module.exports = exports;
